<template>
	<Teleport to="body" v-if="enabled">
		<div ref="scrollUpEl" id="scrollUpButton" class="scrollUpButton activeclick" @click="scrollToTop" style="display: none;">
			<sym-icon name="up-full"/>
		</div>
	</Teleport>
</template>

<script setup lang="ts">
import {computed, onMounted, ref} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";

const enabled = computed<boolean>(() => {
	return !!env.user.scrollUpButton;
});

const env = injectEnv();
const scrollUpEl = ref(null);

function scrollToTop() {
	window.scrollTo({
		top: 0,
		behavior: 'smooth' 
	});
}

function handleScroll() {
	if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
		scrollUpEl.value.style.display = 'block';
	} else {
		scrollUpEl.value.style.display = 'none';
	}
}

onMounted(() => {
	if (enabled.value) {
		window.addEventListener('scroll', handleScroll);
	}
});
</script>

<style>

</style>